import EmailValueObject from '@/domain/shared/email/EmailValueObject';

export default class EmployeeEmail extends EmailValueObject {}
